import Cookies from 'cookies-js';
import ApiClient from '../../shared/api-client';
import { getDateTimeInSeconds } from './DateUtils';

const client = new ApiClient();

const _authKey = 'fr@nkly-auth';

const getAuthData = () => {
  const authData = Cookies.get(_authKey);

  if (authData) {
    return JSON.parse(authData);
  }

  return null;
};

const saveAuthData = (authData, expires) => {
  let expire = expires;
  const currentTime = getDateTimeInSeconds();
  if (expires) {
    authData.expiredTime = currentTime + expires * 1000;
  } else {
    const expiredTime = getAuthData().expiredTime;
    if (expiredTime) {
      expire = (expiredTime - new Date().getTime()) / 1000;
    }
  }
  Cookies.set(_authKey, JSON.stringify(authData), { expires: expire });
};

const logout = () => {
  Cookies.expire(_authKey);
};

const login = (member) => {
  return client.request({
    method: 'post',
    url: '/login',
    data: { member }
  });
};

const createMember = (member) => {
  return client.request({
    url: '/members',
    method: 'post',
    data: { member }
  });
};

const updateMember = (member, token) => {
  return client.request({
    url: '/members/profiles',
    method: 'put',
    headers: { token },
    data: { member }
  });
};

const getMember = (token) => {
  return client.request({
    url: '/members/profiles',
    headers: { token }
  });
};

const subscribe = ({emailList, token, userId}) => {
  return client.request({
    url: '/members/subscribe',
    method: 'post',
    data: {
      emailList,
      userId
    },
    headers: { token }
  });
};

const unsubscribe = (emailList, token) => {
  return client.request({
    url: '/members/unsubscribe',
    method: 'post',
    data: {
      emailList
    },
    headers: { token }
  });
};

const getUserEmailList = (token) => {
  return client.request({
    url: '/members/userEmailList',
    headers: { token }
  });
};

const getEmailList = () => {
  return client.request({
    url: '/members/emailList'
  });
};

const requestPasswordReset = (email) => {
  return client.request({
    url: '/members/passwordResetRequest',
    method: 'post',
    data: {
      emailaddress: email
    }
  });
};

const resetPassword = (password, token) => {
  return client.request({
    url: `/members/passwordReset/${token}`,
    method: 'post',
    data: {
      password
    }
  });
};

const searchUserByEmail = (emailaddress) => {
  return client.request({
    url: '/members/search',
    method: 'post',
    data: {
      emailaddress
    }
  });
};

const generateRandomPassword = () => {
  /** 10 random alphanumeric (only) characters. */
  return Math.random().toString(36).slice(-10);
};

export default {
  getAuthData,
  saveAuthData,
  logout,
  login,
  getMember,
  createMember,
  updateMember,
  subscribe,
  unsubscribe,
  getUserEmailList,
  getEmailList,
  requestPasswordReset,
  resetPassword,
  searchUserByEmail,
  generateRandomPassword
};



// WEBPACK FOOTER //
// ./app/utils/MemberUtils.js